import { defineComponent as _defineComponent } from 'vue'
import { useDelSectionMutation } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteSection',
  props: {
    sectionId: null,
    sectionLabel: null
  },
  emits: ["delete"],
  setup(__props: any) {





const { mutate: delSection, loading } = useDelSectionMutation()

return { __sfc: true,delSection, loading }
}

})